import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import getIncidentDetailsInitialQuery from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/initial/getIncidentDetailsInitialQuery.ts';
import incidentDetailsCardInitialDataGenerator from '@/modules/adjusterReportModules/IncidentDetails/data/incidentDetailsCardInitialDataGenerator.ts';

const useIncidentDetailsInitial = () => {
  const { id } = useParams();
  const {
    data: incidentDetailsInitialData,
    isPending: incidentDetailsPending,
  } = useQuery({
    queryKey: ['incidentDetailsInitialCard', id],
    queryFn: () => getIncidentDetailsInitialQuery({ id }),
    select: (data) => ({
      ...data,
      detailCardItems: incidentDetailsCardInitialDataGenerator(data),
    }),
  });

  return { incidentDetailsInitialData, incidentDetailsPending };
};

export default useIncidentDetailsInitial;
